import { SpringValue, animated } from '@react-spring/web';
import styled from 'styled-components';

import { Lightning } from '@sorare/core/src/atoms/icons/Lightning';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Wrapper = styled(animated.div)`
  display: inline-flex;
  align-items: center;
  font: var(--t-label-xs);
  font-weight: var(--t-bold);
  @media ${tabletAndAbove} {
    font: var(--t-label-s);
  }
`;

const ImgWrapper = styled.span`
  width: 0.7em;
  display: flex;
  margin-left: 0.25em;
  justify-content: center;
`;

type Props = { score: SpringValue<number> };

export const Score = ({ score }: Props) => {
  return (
    <Wrapper>
      <animated.span>{score.to(v => `${v.toFixed(0)}`)}</animated.span>
      <ImgWrapper>
        <Lightning />
      </ImgWrapper>
    </Wrapper>
  );
};
